enum Sorting {
    Ascending = "Ascending",
    Descending = "Descending",
}

export default Sorting;